import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";

// Custom.
import { BatchSelectionProps } from "./global";
import I18n from "@vocollege/app/dist/modules/Services/I18n";

const BatchSelection: React.FC<BatchSelectionProps> = (props) => {
  const { onChange } = props;
  const [currentTab, setCurrentTab] = useState("single");

  // Effects.

  useEffect(() => {
    if (onChange) {
      onChange(currentTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab]);

  return (
    <>
      <Paper
        elevation={10}
        sx={(theme) => ({ marginBottom: theme.spacing(2), overflow: "hidden" })}
      >
        <Tabs
          className="vo-tabs"
          centered
          variant="fullWidth"
          value={currentTab}
          onChange={(event, value) => setCurrentTab(value)}
        >
          <Tab label={I18n.get.vocertActions.createOne} value="single" />
          <Tab label={I18n.get.vocertActions.createMultiple} value="multiple" />
        </Tabs>
      </Paper>
    </>
  );
};

export default BatchSelection;
